// @ts-nocheck

export type TicketGetWithProperty = typeof TicketGetWithProperty[keyof typeof TicketGetWithProperty];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithProperty = {
  true: 'true',
  false: 'false',
} as const;
